import React from "react"
import Svg from "../../utils/Svg"
import Path from "../../utils/Path"

const ShareIOSSvg = ({ color = "primary", bg, iconStyle, ...rest }) => {
  return (
    <Svg
      width="33"
      height="33"
      viewBox="-4.4 0 28 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M7.5 5L10 2.5L12.5 5"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <Path
        d="M10 10.8333L10 2.5"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <Path
        d="M14.1693 8.33398H15.8359C16.2962 8.33398 16.6693 8.70708 16.6693 9.16732V16.6673C16.6693 17.1276 16.2962 17.5007 15.8359 17.5007H4.16927C3.70903 17.5007 3.33594 17.1276 3.33594 16.6673V9.16732C3.33594 8.70708 3.70903 8.33398 4.16927 8.33398H5.83594"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </Svg>
  )
}

export default ShareIOSSvg
